module.exports = __webpack_public_path__ + "img/undraw_moonlight_5ksn.0d71bf3d.svg";